export const config = {
  api: {
    transaction: {
      url: "https://validation.agilesigner.com/api-transaction/api/public",
    },
    twofa: {
      url: "https://validation.agilesigner.com/api-2fa/api/2fa",
    },
  },
};
